<div class="alert-box slide-top">
  @if (promptType===type.INSTALL) {
    <button (click)="onInstall()"
      class="btn start-button black-outline"
      tabindex="0">
      <div aria-hidden="true">{{ "shared.install" |translate }}</div>
      <div class="sr-only" id="install-app-title">({{ 'accessibility.installDialogOpen' | translate }})</div>
      <div class="sr-only" id="install-app-description">({{ 'accessibility.installApp' | translate }})</div>
    </button>
  }


  @if (promptType===type.SAFARI || promptType===type.CHROME || promptType===type.FIREFOX || promptType===type.EDGE || promptType===type.SAMSUNG) {
    <div
      class="text-center">
      <div aria-live="polite" class="instruction-line">
        <div class="line-text">{{ "shared.toInstallTap" | translate }}</div>
      </div>
      @if (promptType===type.SAFARI) {
        <div aria-live="polite" class="instruction-line">
          <img alt="iOS Share icon" class="ios-img" loading="lazy"
            src="assets/scalableVectorGraphics/install-banner/ios-share.webp" />
            <div class="line-text">{{ "shared.safariInstructions" | translate }}</div>
          </div>
          <div aria-live="polite" class="instruction-line">
            <div class="line-text">{{ "shared.installSafari" | translate }}</div>
            <mat-icon>add_box</mat-icon>
          </div>
          <div aria-hidden="true" class="small-screen-space"></div>
        }
        @if (promptType===type.CHROME) {
          <div aria-live="polite" class="instruction-line">
            <img alt="Install banner" id="vertical-dots-img"
              loading="lazy" src="assets/scalableVectorGraphics/install-banner/more.svg" />
              <div class="line-text">{{ "shared.chromeInstructions" | translate }}</div>
            </div>
            <div aria-live="polite" class="instruction-line">
              <div class="line-text">{{ "shared.installChrome" | translate }}</div>
              <mat-icon>install_mobile</mat-icon>
            </div>
          }
          @if (promptType===type.FIREFOX) {
            <div aria-live="polite" class="instruction-line">
              <img alt="Install banner" loading="lazy" src="assets/scalableVectorGraphics/install-banner/more.svg" />
              <div class="line-text">{{ "shared.safariInstructions" | translate }}</div>
            </div>
            <div aria-live="polite" class="instruction-line">
              <div class="line-text">{{ "shared.installFirefox" | translate }}</div>
              <mat-icon>install_mobile</mat-icon>
            </div>
          }
          @if (promptType===type.EDGE) {
            <div aria-live="polite" class="instruction-line">
              <img alt="Install banner" class="margin-img" loading="lazy"
                src="assets/scalableVectorGraphics/install-banner/dots-horizontal.svg" />
                <div class="line-text">{{ "shared.safariInstructions" | translate }}</div>
              </div>
              <div aria-live="polite" class="instruction-line">
                <div class="line-text">{{ "shared.installEdge" | translate }}</div>
                <mat-icon>install_mobile</mat-icon>
              </div>
            }
            @if (promptType===type.SAMSUNG) {
              <div aria-live="polite" class="instruction-line">
                <img alt="Install banner" class="margin-img" loading="lazy"
                  src="assets/scalableVectorGraphics/install-banner/menu.svg" />
                  <div class="line-text">{{ "shared.installSamsung1" | translate }}</div>
                  <img alt="Install banner" class="margin-img" loading="lazy"
                    src="assets/scalableVectorGraphics/install-banner/add.svg" />
                  </div>
                  <div aria-live="polite" class="instruction-line">
                    <div class="line-text">{{ "shared.installSamsung2" | translate }}</div>
                  </div>
                }
              </div>
            }


            @if (promptType===type.CHRIOS) {
              <div
                class="text-center">
                {{ "shared.switchToSafari" | translate }}
              </div>
            }
            @if (promptType===type.NOTSUPPORTED) {
              <div
                class="text-center">
                {{ "shared.supportedBrowsersAre" | translate }}
              </div>
            }
            @if (promptType===type.FACEBOOK) {
              <div
                class="text-center">
                {{ "shared.fbBrowserNotSupported" | translate }}
              </div>
            }
          </div>
